export enum ReportJobType {
  ShippingGuideV1 = 1,
  ShippingGuideV2 = 2
}

export const reportJobTypeMapper = {
  [ReportJobType.ShippingGuideV1]: 'Guia de Remessa',
  [ReportJobType.ShippingGuideV2]: 'Guia de Remessa',
}